export default __webpack_public_path__ + "static/media/hht2_direction_speakingpractice_01.4c029811.png";